var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-user-item-container"},[(_vm.item.FLAG_f_off == 1)?_c('div',[_vm._v("отключена")]):_vm._e(),_c('div',[_c('b',[_vm._v(_vm._s(_vm.item.f))]),_vm._v(" л. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }